import { InteractivePianoRollContextType, PianoRollNote } from '../types'
import { widthToTicks, zoomLevelToZoomFactor } from '../utils/pianoRollUtils'
import { detectNoteAndDragForPos, getRelativeMousePositionInDiv } from '../utils/positionHelper'

const highlightSmartScaleNotesAtTick = (context: InteractivePianoRollContextType, atTicks: number) => {
  const { smartScaleNotes, setSmartScaleNotes } = context

  setSmartScaleNotes((prevNotes: PianoRollNote[]) => {
    let changedCount = 0
    const updatedNotes = prevNotes.map((note: PianoRollNote) => {
      const newOpacity = note.startTicks <= atTicks && note.endTicks > atTicks ? 1 : 0
      if (note.opacity !== newOpacity) {
        changedCount++
      }
      return newOpacity !== note.opacity ? { ...note, opacity: newOpacity } : note
    })

    return changedCount > 0 ? updatedNotes : prevNotes
  })
}

export const handleMouseMove = (context: InteractivePianoRollContextType, posX: number, posY: number, refs: any) => {
  const { baseGridWidth, ppq, zoomLevelRef, mousePositionRef, autocompleteNotes, setAutocompleteNotesHovered } = context

  const { containerRef } = refs
  const { x, y } = getRelativeMousePositionInDiv(posX, posY, containerRef)

  mousePositionRef.current = { x: posX, y: posY }

  const ticks = widthToTicks(x, zoomLevelToZoomFactor(zoomLevelRef.current), baseGridWidth, ppq)

  highlightSmartScaleNotesAtTick(context, ticks)

  const autocompleteNote = detectNoteAndDragForPos(context, x, y, true, autocompleteNotes)
  if (autocompleteNote) {
    setAutocompleteNotesHovered(true)
  } else {
    setAutocompleteNotesHovered(false)
  }
}

export const handlePointerLeave = (context: InteractivePianoRollContextType) => {
  highlightSmartScaleNotesAtTick(context, -1)
}
